'use strict';
import { module } from '../app';
import pubsubService from '../services/pubsub.service';

class ChatConversationController {
  static $inject = ['$scope', '$stateParams', '$state', '$timeout', 'techpadOptions'];

  constructor($scope, $stateParams, $state, $timeout, techpadOptions) {
    this.$state = $state;
    this.$scope = $scope;
    this.$stateParams = $stateParams;
   
    this.conversationId = $stateParams.conversationId;
    document.addEventListener("resume", this.handleResumeEvent, false);
    pubsubService.on('REFRESH_CONVERSATION', () => this.safeRefresh());

    this.$scope.vm = this;
    this.$scope.vm.forceReload = false;

    techpadOptions.getOptions();
    this.$scope.vm.darkMode = techpadOptions.options.DarkMode;

    this.$timeout = $timeout;
    $scope.$on('$destroy', () => {
      pubsubService.dispatch('CLOSE_CHAT_WINDOW');
    });
  }

  goBack() {
    this.$state.go('root.worklist');
  }

  safeRefresh() {
    this.$scope.vm.forceReload = true;
    this.$timeout( () => {return this.$scope.vm.forceReload = false;}, 200);    
  }
}

module.controller('ChatConversationController', [
  ...ChatConversationController.$inject,
  ChatConversationController
]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/chatConversationController.js